import { CallContent } from "../../../Components/CallApp/CallApp";

export const Area51CallContent: CallContent[] = [
  {
    Contact: "+3 132 515 1007",
    date: "12 Sep 2024",
    time: "9:59 PM",
    type: "outgoing",
  },
  {
    Contact: "+3 118 629 2167",
    date: "12 Sep 2024",
    time: "9:56 PM",
    type: "missed",
  },
  {
    Contact: "Mom",
    date: "11 Sep 2024",
    time: "9:14 PM",
    type: "incoming",
  },
  {
    Contact: "Natalia",
    date: "8 Sep 2024",
    time: "4:38 PM",
    type: "missed",
  },
  {
    Contact: "Natalia",
    date: "8 Sep 2024",
    time: "4:37 PM",
    type: "missed",
  },
  {
    Contact: "Natalia",
    date: "8 Sep 2024",
    time: "4:36 PM",
    type: "missed",
  },
];
